import CollapseImageDetails from '../collapseImageDetails/collapseImageDetails.vue'

export default {
  name: 'CollapseImageDetails',
  components: {CollapseImageDetails},
  props: ['id', 'title', 'dataImg', 'group', 'requestId', 'isPdf'],

  data () {
    return {
      changeAngel: false
    }
  },
  methods: {
    changeAcording () {
      this.changeAngel = !this.changeAngel
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/collapseImageDetails/collapseImageDetails.js